import React from "react";
import { useState, useEffect } from "react";
import { Grid } from "@mui/material";

import {
  Stack,
  CustomListItem,
  CustomSlider,
  SideList,
  FormModal,
} from "../../components";

import BettingIcon from "../../Svg/BettingIcon";
import UtilityIcon from "../../Svg/UtilityIcon";
import CableIcon from "../../Svg/CableIcon";
import AirTimeIcon from "../../Svg/AirTimeIcon";
import DataIcon from "../../Svg/DataIcon";
import OtherBillIcon from "../../Svg/OtherBillIcon";

import { useNavigate } from "react-router-dom";
import { ApiUrls } from "../../Services/Routes/API";
import { headersPost } from "../../Services/API";
import { MainRoutes } from "../../Services/Routes/App";
import TransactionBar from "../../components/TransactionBar";

const Wallet = () => {
  //const
  const navigate = useNavigate();

  // styling
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,

    // border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    borderTop: "5px solid #00008B",
    display: "flex",
    flexDirection: "column",
  };
  const [modalOpen, setModalOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [cards, setCards] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [defaultWallet, setDefaultWallet] = useState("");

  // const
  const handleOpen = () => {
    setModalOpen(true);
  };
  const modalClose = () => {
    setModalOpen(false);
  };

  const lists = [
    {
      icon: <BettingIcon />,
      text: "Betting",
    },
    {
      icon: <UtilityIcon />,
      text: "Utility Bills",
    },
    {
      icon: <CableIcon />,
      text: "Cable",
    },
    {
      icon: <AirTimeIcon />,
      text: "Airtime",
    },
    {
      icon: <DataIcon />,
      text: "Data",
    },
    {
      icon: <OtherBillIcon />,
      text: "Other Bill Payments",
    },
  ];
  // Request for Transection Data
  const getCardsData = () => {
    const data = {
      request_type: "wallet",
    };
    setOpen(true);
    headersPost(ApiUrls.GET_DASHBOARD_DATA, data)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setCards(res.data?.wallets);

          setOpen(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  useEffect(() => {
    getCardsData();
  }, []);

  useEffect(() => {
    if (cards) {
      const DEFAULT_WALLET_ARR = cards.filter((card) => {
        return card?.is_default == true;
      });
      setDefaultWallet(DEFAULT_WALLET_ARR[0]);
    }
  }, [cards]);

  return (
    <>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 6 }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={8}
          sx={{ marginTop: "40px", width: "72vw" }}
        >
          <Stack />
          <CustomSlider cards={cards} />
          <TransactionBar text="Fund Wallet"/>
         
         
        </Grid>
        <Grid item sm={4} xs={12} marginTop="50px" >
          <SideList cards={cards} />
        </Grid>
        <Grid item sm={8} xs={8} md={8}>
        <CustomListItem defaultWallet={defaultWallet} cards={cards} />
      </Grid>
      </Grid>
    </>
  );
};

export default Wallet;
